import {css} from '@emotion/css';
import {LayoutBackground, SidebarVariant, SidebarPropsExtended} from './LayoutSection.types';
import {Breakpoints, mq} from '../../../../styles/js/mixins/media-queries';
import {colours, spacing, elementSize} from '../../../../styles/js/variables';

const getBgColour = (type?: LayoutBackground) => {
  switch (type) {
    case LayoutBackground.GRAY:
      return `${colours.background.SECTION}`;
    case LayoutBackground.ACCENT:
      return `${colours.brand.PRIMARY}`;
    case LayoutBackground.BLUE:
      return `${colours.brand.SECONDARY_DISABLED}`;
    default:
      return `${colours.background.MAIN}`;
  }
};

const styles = {
  container: (type?: LayoutBackground): string => css`
    label: layoutSection-container;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    overflow: hidden;
    background: ${getBgColour(type)};

    ${mq(Breakpoints.DESKTOP)} {
      flex-direction: row;
    }

    & + & {
      .layoutSection__main {
        padding-top: 0;
      }
    }
  `,
  main: (slim?: boolean, sidebar?: SidebarPropsExtended): string => css`
    label: layoutSection-main;
    position: relative;
    display: flex;
    justify-content: ${sidebar ? 'flex-end' : 'flex-start'};
    width: 100%;
    padding: ${slim ? 0 : spacing.S} ${spacing.XS};

    ${mq(Breakpoints.TABLET)} {
      ${sidebar &&
      ` padding: ${spacing.L} ${spacing.XS};
        justify-content: center;`};
    }

    ${mq(Breakpoints.DESKTOP)} {
      position: inherit;
      width: ${sidebar ? 'calc((100% / 12) * 7)' : elementSize.container.LG};
      padding: ${slim ? 0 : spacing.XL} ${spacing.XS};
      ${sidebar &&
      `justify-content: flex-end;
       padding-right: 0;`};
    }
  `,
  mainInner: (sidebar?: SidebarPropsExtended): string => css`
    label: layoutSection-mainInner;
    width: 100%;
    max-width: 100%;

    ${mq(Breakpoints.TABLET)} {
      max-width: ${sidebar ? `calc((${elementSize.container.SM} / 12) * 10)` : elementSize.container.LG};
    }

    ${mq(Breakpoints.DESKTOP)} {
      max-width: ${sidebar ? `calc((${elementSize.container.LG} / 12) * 7);` : elementSize.container.LG};
      padding-right: ${sidebar ? `calc(${elementSize.container.LG} / 12)` : 0};
    }
  `,
  partner: css`
    label: layoutSection-partner;
    display: flex;
    justify-content: center;
    margin-bottom: ${spacing.XS};
  `,
  sidebarWrap: (sidebarVariant?: SidebarVariant): string => css`
    label: layoutSection-sidebar;
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: ${sidebarVariant === SidebarVariant.DARK ? colours.background.SECTION : 'transparent'};

    ${mq(Breakpoints.TABLET)} {
      justify-content: stretch;
      padding-right: ${spacing.XS};
      padding-left: ${spacing.XS};
    }

    ${mq(Breakpoints.DESKTOP)} {
      justify-content: flex-start;
      width: calc((100% / 12) * 5);
      padding: ${spacing.XL} ${spacing.XS} ${spacing.XL} 0;
    }
  `,
  sidebarWrapInner: (sidebarVariant?: SidebarVariant): string => css`
    label: layoutSection-sidebarInner;
    padding-top: ${spacing.XS};

    ${mq(Breakpoints.TABLET)} {
      width: 100%;
      padding-bottom: ${spacing.XS};
    }

    ${mq(Breakpoints.DESKTOP)} {
      max-width: 100%;
      padding-top: 0;
      /* stylelint-disable-next-line sh-waqar/declaration-use-variable */
      padding-left: calc(${elementSize.container.LG} / 12);
      border-left: ${sidebarVariant !== SidebarVariant.DARK ? `1px solid ${colours.border.LIGHT_GRAY}` : ''};
    }
  `,
};

export default styles;
